import { Consultant, DivisionType } from './common'

export const RevivalTypeRequest = {
  ep: 'ep',
  le: 'le',
} as const
export type RevivalTypeRequest =
  (typeof RevivalTypeRequest)[keyof typeof RevivalTypeRequest]

export const RevivalStatus = {
  in_process: 'in_process',
  success: 'success',
  failed: 'failed',
} as const
export type RevivalStatus = (typeof RevivalStatus)[keyof typeof RevivalStatus]

export const RevivalProductName = {
  mKassa: 'mkassa',
  mPlus: 'mplus',
} as const
export type RevivalProductName =
  (typeof RevivalProductName)[keyof typeof RevivalProductName]

export type RevivalShortObject = {
  id: string
  product_name: RevivalProductName
  name: string
  inn: string
  type_request: RevivalTypeRequest
  status: RevivalStatus
  created_at: string
  point_address: string
  success_date: string
  consultant_name: string
  supervisor_name: string
  product_turnover?: {
    amount: string
    count: number
    name: string
    code: string
  }
  turnover_period_from: string
  turnover_period_to: string
}

export interface RevivalObject {
  id: string
  product_name: RevivalProductName
  consultant: Consultant
  supervisor_name: string
  created_at: string
  progress: number
  status: RevivalStatus
  name: string
  start_date: string
  end_date: string
  type_request: RevivalTypeRequest
  phone_number: string
  comment: string
  training_completed: boolean
  promo_materials_left: boolean
  other_documents: Array<{
    id: number
    file: string
  }>
}
